module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-58.296ac068.svg";